export default "__VITE_ASSET__BBMCLefI__"